import React from "react";
import PropTypes from "prop-types";
import { Text } from "../../Text/Text";

import "./SearchOption.scss";

export class SearchOption extends React.Component {
  static propTypes = {
    option: PropTypes.object,
    onClick: PropTypes.func,
    renderOption: PropTypes.func,
  };

  onClick = () => {
    const { onClick, option } = this.props;

    onClick(option);
  };

  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.onClick();
    }
  };

  render() {
    const { option, renderOption } = this.props;

    return (
      <div
        className="SearchOption"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        tabIndex={0}
        role="button"
        data-testid="SearchOption"
      >
        {renderOption ? (
          renderOption(option)
        ) : (
          <Text type="P" weight="Light">
            {option.label}
          </Text>
        )}
      </div>
    );
  }
}

export default SearchOption;
